import ServiceDetailPage from "../../ones/ServiceDetailPage";
import Footer from "../../ones/Footer";
import image1 from "../../assets/banner4.jpg";
import image2 from "../../assets/banner7.jpg";
import image3 from "../../assets/banner5.jpg";

export default function ServiceSesame() {
  return (
    <>
      <ServiceDetailPage
        label="Coal"
        title="Coal Mining & Transportation"
        subtitle="Coal extraction and transportation services with local and cross-border capability for industrial and commercial demand."
        overview="NCCL supports coal supply chains through operational mining support and transport planning designed for dependable movement, risk control, and route compliance."
        images={[
          {
            src: image1,
            alt: "Coal operation",
            captionTitle: "Coal Operations",
            captionText: "Structured mining and handling for steady operational flow.",
          },
          {
            src: image2,
            alt: "Cross border transport",
            captionTitle: "Cross-Border Reach",
            captionText: "Transport capability beyond local delivery corridors.",
          },
          {
            src: image3,
            alt: "Coal logistics",
            captionTitle: "End-to-End Movement",
            captionText: "Coordinated loading, movement, and client handoff.",
          },
        ]}
        highlights={[
          "Coal mining operations supported by field-ready equipment.",
          "Cross-border transportation with route-aware planning.",
          "Safety and reliability controls throughout movement cycles.",
        ]}
        metrics={[
          { value: "Cross-Border", label: "Transport capability" },
          { value: "Heavy-Duty", label: "Operational equipment class" },
          { value: "Coordinated", label: "Mining-to-delivery workflow" },
        ]}
      />
      <Footer />
    </>
  );
}
